import { render, staticRenderFns } from "./baseInfo.vue?vue&type=template&id=7d255c90&scoped=true&"
import script from "./baseInfo.vue?vue&type=script&lang=js&"
export * from "./baseInfo.vue?vue&type=script&lang=js&"
import style0 from "./baseInfo.vue?vue&type=style&index=0&id=7d255c90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d255c90",
  null
  
)

export default component.exports